import { SectionHeading } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/components/SectionHeading';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import { JournalInfoTableView } from './Table';

type JournalInfoProps = { reportId: string };

export const JournalInfo: FC<JournalInfoProps> = memo(({ reportId }) => {
  const { t } = useTranslation();

  return (
    <SectionHeading title={t('journal_entry.section_title')}>
      <JournalInfoTableView reportId={reportId} />
    </SectionHeading>
  );
});
JournalInfo.displayName = 'JournalInfo';
